var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.ready)?_c('PieChart',{staticClass:"px-6",attrs:{"top10Labels":_vm.top10Labels,"top10Data":_vm.top10Data}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }